import { render, staticRenderFns } from "./SelectorLocalidadeEmpresas.vue?vue&type=template&id=08f40027&scoped=true"
import script from "./SelectorLocalidadeEmpresas.vue?vue&type=script&lang=js"
export * from "./SelectorLocalidadeEmpresas.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "@/vendor/libs/vue-input-tag/vue-input-tag.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f40027",
  null
  
)

export default component.exports